import { MutationTree } from 'vuex';
import { SingleFilter } from '@/store/types';
import { SalesReportState } from './types';
import { SalesReportResource, SalesReportRequest, InterestResource, MaterialResource} from '@/api/requests/sales-report/types';
import moment from 'moment';

export const mutations: MutationTree<SalesReportState> = {

    /** SalesReports */

    /**
     * Add an SalesReport to the list.
     *
     * @param state
     * @param salesReport
     */
    addSalesReport(state, salesReport: SalesReportResource) {
        state.salesReports.push(salesReport);
    },

    /**
     * Remove an salesReport from the list.
     *
     * @param state
     * @param salesReportId
     */
    removeSalesReport(state, salesReportId: number) {
        state.salesReports = state.salesReports.filter((salesReport) => salesReport.id !== salesReportId);
    },

    /**
     * Set the salesReports list.
     *
     * @param state
     * @param salesReports
     */
    setSalesReports(state, salesReports: SalesReportResource[]) {
        state.salesReports = salesReports;
    },


    /**
     * Reset salesReports
     *
     * @param state
     */
    resetSalesReports(state) {
        state.salesReports = [];
    },

    /**
     * Update a salesReport.
     *
     * @param state
     * @param salesReport
     */
    updateSalesReport(state, salesReport: SalesReportResource) {
        const index = state.salesReports.findIndex((item) => item.id === salesReport.id);
        state.salesReports.splice(index, 1, salesReport);
    },

    /**
     * Set the active task id.
     *
     * @param state
     * @param id
     */
    setActiveSalesReportId(state, id: number) {
        state.activeSalesReportId = id;
    },

    /**
     * Update a salesReport.
     *
     * @param state
     * @param task
     */
    upsertSalesReport(state, salesReport: SalesReportResource) {
        const index = state.salesReports.findIndex((item) => item.id === salesReport.id);
        if (index > -1) {
            state.salesReports.splice(index, 1, salesReport);
        } else {
            state.salesReports.push(salesReport);
        }
    },


    /** Filters */

    /**
     * Set a query filter in state.
     *
     * @param state
     * @param key
     * @param value
     */
    setFilter(state, { key, value }: SingleFilter) {
        state.filters = { ...state.filters, [key]: value };
    },

    /**
     * Reset a single filter.
     *
     * @param state
     * @param key
     */
    resetFilter(state, key: string) {
        delete state.filters[key];
    },

    /**
     * Set active filters in sales reports.
     *
     * @param state
     * @param filters
     */
    setFilters(state, filters: any) {
        state.filters.profile_id = filters.profile_id || undefined;
    },

    /**
     * Reset query filters.
     *
     * @param state
     */
    resetFilters(state) {
        state.filters = {};
    },
};
